// Sort a list of items by `created_at` (or fallback `updated_at`), newest first.
// Items missing both fields are pushed to the end but kept in their original
// relative order.
export function sortByLatest(items) {
  const now = new Date();
  return [...items].sort((a, b) => {
    const at = a?.created_at || a?.updated_at;
    const bt = b?.created_at || b?.updated_at;
    if (!at && !bt) return 0;
    if (!at) return 1;
    if (!bt) return -1;
    return new Date(bt || now) - new Date(at || now);
  });
}

// How many items to show by default on a listing page. Doubles as the
// threshold below which the "Show more" toggle is hidden.
export const INITIAL_ITEMS = 4;
